export default {
  baseStyle: {
    dialog: {
      bg: 'brand.dark',
      border: '1px solid #252424',
    },
  },
};
